import { useTranslation } from 'react-i18next';
import { ArrowRight, BookOpen, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const articlePaths: Record<string, string> = {
  pt: '/artigo/',
  en: '/article/',
  de: '/artikel/',
};

export default function HeroSection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = i18n.language || 'pt';

  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20sneaker%20and%20streetwear%20collection%20displayed%20on%20floating%20white%20shelves%2C%20soft%20warm%20natural%20light%2C%20mint%20green%20and%20cream%20pastel%20accents%2C%20clean%20modern%20editorial%20photography%2C%20airy%20minimal%20aesthetic&width=1600&height=900&seq=hero-main-2026&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-medium mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-400" />
            {t('heroEyebrow')}
          </div>

          <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight text-shadow-lg mb-6">
            {t('heroTitle')}
          </h1>

          <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8 max-w-xl text-shadow-sm">
            {t('heroDescription')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-brand-600 hover:bg-brand-700 text-white rounded-xl font-medium text-sm transition-colors shadow-lg shadow-brand-900/20"
            >
              {t('ctaExplore')}
              <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href={articlePaths[currentLang] || '/artigo/'}
              onClick={(e) => { e.preventDefault(); navigate(articlePaths[currentLang] || '/artigo/'); }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white rounded-xl font-medium text-sm transition-colors border border-white/20"
            >
              <BookOpen className="w-4 h-4" />
              {t('ctaGuide')}
            </a>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-accent-600 hover:bg-accent-700 text-white rounded-lg font-medium text-sm transition-colors"
            >
              CSSBuy Spreadsheet
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-lg font-medium text-sm transition-colors border border-white/20"
            >
              Buy It Now
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>

          <p className="mt-6 text-xs text-white/60 text-shadow-sm flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-white/40" />
            {t('trustLine')}
          </p>
        </div>
      </div>
    </section>
  );
}